module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "breadcrumbs",
    class: _vm.rootClasses
  }, [_c('div', {
    staticClass: "breadcrumbs--gradient"
  }), _vm._v(" "), _c('ol', {
    staticClass: "u-reset breadcrumbs--items",
    attrs: {
      "itemscope": "",
      "itemtype": "http://schema.org/BreadcrumbList"
    }
  }, _vm._l((_vm.tree), function(item, itemIdx) {
    return _c('li', {
      staticClass: "breadcrumbs--item",
      class: _vm.breadcrumbItemClasses(itemIdx),
      attrs: {
        "itemscope": "",
        "itemprop": "itemListElement",
        "itemtype": "http://schema.org/ListItem"
      }
    }, [_c('span', {
      staticClass: "breadcrumbs--link-wrap"
    }, [_c('router-link', {
      staticClass: "u-reset breadcrumbs--link",
      attrs: {
        "to": item.path,
        "itemscope": "",
        "itemtype": "http://schema.org/Thing",
        "itemprop": "item"
      }
    }, [_c('span', {
      staticClass: "breadcrumbs--link-inner",
      attrs: {
        "itemprop": "name"
      },
      domProps: {
        "innerHTML": _vm._s(item.title)
      }
    })]), _vm._v(" "), _c('meta', {
      attrs: {
        "itemprop": "position",
        "content": itemIdx + 1
      }
    }), _vm._v(" "), (!_vm.isLast(itemIdx)) ? _c('cmp-icon', {
      staticClass: "breadcrumbs--chevron",
      attrs: {
        "symbol": "chevron_right",
        "size": "x-small"
      }
    }) : _vm._e()], 1)])
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e07d095e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e07d095e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/breadcrumbs/index.vue
// module id = 588
// module chunks = 7